import * as React from "react";
import i18next from "i18next";
import { WidgetToolbarButton } from "../Widget/WidgetToolbarButton";
import { useCallback } from "react";
import { useMapDownloadContext } from "../../Contexts/MapDownloadContext";
import { SheetSelectMode } from "../enums";

export const MapSelect = (): JSX.Element => {
    const { sheetSelectMode, setSheetSelectMode } = useMapDownloadContext();

    const onClickSelect = useCallback(() => {
        setSheetSelectMode(sheetSelectMode && sheetSelectMode === SheetSelectMode.Click ? null : SheetSelectMode.Click);
    }, [sheetSelectMode]);

    return (
        <WidgetToolbarButton
            iconClass="icon-geolite-pin"
            buttonClass={sheetSelectMode && sheetSelectMode === SheetSelectMode.Click ? "active" : ""}
            title={i18next.t("mapDownload.drawClick")}
            onClick={onClickSelect}
        />
    );
};
